import gql from "graphql-tag";
import {contentPostDetailsFragment} from "./contentPostDetailsFragment";

export const contentListPageQuery = gql`
    query ContentListPageQuery(
        $topics: [String]
        $universityId: String
        $universitySlug: String
        $degrees: [String]
        $authorId: String
        $limit: LimitedInt
        $offset: Int
        $title: String
        $order: String
    ) {
        allPostsInfo(
            topics: $topics
            universityId: $universityId
            universitySlug: $universitySlug
            degrees: $degrees
            authorId: $authorId
            safeLimit: $limit
            offset: $offset
            title: $title
            order: $order
        ) {
            blogPosts {
                ...ContentPostDetailsFragment
            }
            blogPostsCount
            blogPostsTopics
            blogPostsAuthors
            blogPostsDegrees {
                id
                name
            }
        }
    }

    ${contentPostDetailsFragment}
`;
